<template>
  <van-popup
    v-model="modelValue"
    position="bottom"
    class="transparent__popup"
    get-container="body"
  >
    <div class="popup-wrapper">
      <div class="line"></div>
      <div class="main-wrapper">
        <h2 class="title">自定义日期范围</h2>
        <ul class="time-date-wrap">
          <li class="time-date-time">
            <span class="label">开始时间</span><span class="v-line"></span>
            <span
              @click="showStartDatePicker = true"
              :class="['value', !this.formatStartDate && 'empty']"
              >{{ formatStartDate || '请选择开始时间' }}</span
            >
          </li>
          <li class="time-date-time">
            <span class="label">结束时间</span><span class="v-line"></span>
            <span
              @click="showEndDatePicker = true"
              :class="['value', !this.formatEndDate && 'empty']"
              >{{ formatEndDate || '请选择结束时间' }}</span
            >
          </li>
        </ul>
        <div class="bottom-bar">
          <span
            v-if="showCancelButton"
            @click="$emit('input', false)"
            class="button"
            >{{ cancelText }}</span
          >
          <span @click="handleConfirm" class="button active">确定</span>
        </div>
      </div>
    </div>
    <!-- 日期选择器 -->
    <van-popup
      v-model="showStartDatePicker"
      position="bottom"
      get-container="body"
      class="date_bottom_popup"
    >
      <van-datetime-picker
        v-model="startDate"
        :type="dateType"
        :title="datePickerTitle"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="() => (showStartDatePicker = false)"
        @cancel="cancelStartPopover"
      />
    </van-popup>
    <van-popup
      v-model="showEndDatePicker"
      position="bottom"
      get-container="body"
      class="date_bottom_popup"
    >
      <van-datetime-picker
        v-model="endDate"
        :type="dateType"
        :title="datePickerTitle"
        :min-date="minDate"
        :max-date="allowSelectTodayAfterTime ? defaultMaxFinishDate : maxDate"
        @confirm="() => (showEndDatePicker = false)"
        @cancel="cancelEndPopover"
      />
    </van-popup>
  </van-popup>
</template>

<script>
import moment from 'moment'
export default {
  name: 'CustomDateTimePopup',
  props: {
    allowSelectTodayAfterTime: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    value: {
      default: false,
      type: Boolean,
    },
    beginDate: String, // 开始时间
    overDate: String, // 结束时间
    cancelText: {
      type: String,
      default: () => {
        return '取消'
      },
    },
    maxRangeDay: {
      type: Number,
      default: 0,
    },
    rangeName: {
      type: String,
      default: () => {
        return ''
      },
    },
    showCancelButton: Boolean,
    sameYear: Boolean, // 不允许跨年
    dateType: {
      type: String,
      default: () => {
        return 'datetime'
      },
    },
    limitDay: [String, Number],
    // 限制最小时间
    minDateValue: [Number, String],
    // 限制最大时间
    maxDateValue: [Number, String],
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    formatStr() {
      const formatItem = {
        'year-month': 'YYYY-MM',
        date: 'YYYY-MM-DD',
        datetime: 'YYYY-MM-DD HH:mm',
        'date-second': 'YYYY-MM-DD HH:mm:ss',
      }
      return formatItem[this.dateType] || 'YYYY-MM-DD HH:mm'
    },
    formatStartDate({ startDate, allowEmpty }) {
      if (startDate) {
        return moment(startDate).format(this.formatStr)
      } else {
        if (allowEmpty) {
          return ''
        } else {
          return moment(new Date())
            .subtract(7 - 1, 'days')
            .format(this.formatStr)
        }
      }
      // return startDate
      //   ? moment(startDate).format('YYYY-MM-DD')
      //   : moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD')
    },
    formatEndDate({ endDate, allowEmpty }) {
      // return endDate
      //   ? moment(endDate).format('YYYY-MM-DD')
      //   : moment(new Date()).format('YYYY-MM-DD')
      if (endDate) {
        return moment(endDate).format(this.formatStr)
      } else {
        if (allowEmpty) {
          return ''
        } else {
          return moment(new Date()).format(this.formatStr)
        }
      }
    },
    datePickerTitle() {
      if (this.dateType == 'year-month') {
        return '选择年月'
      }
      return '选择年月日'
    },
  },
  data() {
    return {
      moment,
      showStartDatePicker: false,
      showEndDatePicker: false,
      startDate: '',
      endDate: '',
      minDate: new Date(2015, 0, 1),
      maxDate: new Date(),
      defaultMaxFinishDate: new Date(
        new Date().getFullYear() + 10,
        new Date().getMonth(),
        new Date().getDate()
      ),
    }
  },
  watch: {
    modelValue: {
      handler(val) {
        console.log('===modelValue: ', val)
        if (this.allowEmpty) return
        this.startDate = this.$props.beginDate
          ? new Date(this.$props.beginDate.replace(/\-/g, '/'))
          : new Date(moment(new Date()).subtract(7 - 1, 'days'))
        this.endDate = this.$props.overDate
          ? new Date(this.$props.overDate.replace(/\-/g, '/'))
          : new Date()
      },
      immediate: true,
    },
    minDateValue: {
      handler(val) {
        if (val) {
          this.minDate = new Date(val)
        }
      },
      immediate: true,
    },
    maxDateValue: {
      handler(val) {
        if (val) {
          this.maxDate = new Date(val)
        }
      },
      immediate: true,
    },
  },
  methods: {
    cancelEndPopover() {
      this.showEndDatePicker = false
      this.endDate = this.overDate || new Date()
    },
    cancelStartPopover() {
      this.showStartDatePicker = false
      this.startDate =
        this.beginDate || new Date(moment(new Date()).subtract(7 - 1, 'days'))
    },
    resetDate() {
      this.startDate = this.beginDate
      this.endDate = ''
    },
    handleConfirm() {
      if (!this.formatStartDate) {
        return this.$toast('请选择开始时间')
      }
      if (!this.formatEndDate) {
        return this.$toast('请选择结束时间')
      }
      if (
        new Date(this.formatEndDate).getTime() <
        new Date(this.formatStartDate).getTime()
      ) {
        return this.$toast('结束时间不能小于开始时间')
      }
      if (this.maxRangeDay && this.maxRangeDay > 0) {
        // 开始结束时间不允许超过这个天数
        const diffVlaue =
          moment(this.formatEndDate).diff(this.formatStartDate, 'days') + 1
        if (diffVlaue > this.maxRangeDay) {
          return this.$toast(
            this.rangeName + '时间跨度不可超过' + this.maxRangeDay + '天'
          )
        }
      }
      // 核销记录放开跨年查询
      if (this.sameYear) {
        if (
          moment(this.formatStartDate).year() !=
          moment(this.formatEndDate).year()
        ) {
          return this.$toast('不支持跨年筛选时间')
        }
      }
      if (
        this.limitDay &&
        Number(this.limitDay) > 0 &&
        moment(this.formatEndDate).diff(this.formatStartDate, 'days') >
          this.limitDay
      ) {
        return this.$toast(`筛选时间范围不超过${this.limitDay}天`)
      }
      this.$emit('input', false)
      this.$emit('confirm', [this.formatStartDate, this.formatEndDate])
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .search input {
    font-size: 14px;
    font-size: var(--set-font-size14);
  }
}
.transparent__popup {
  background: transparent !important;
}
.date_bottom_popup {
  border-radius: 20px 20px 0px 0px;
  background: #ffffff;
  padding-top: 10px;
  ::v-deep {
    .van-picker-column__item--selected {
      color: #006cff;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #006cff;
      line-height: 24px;
      text-align: right;
      font-style: normal;
      text-transform: none;
      background: #f0f7fe;
    }
    .van-picker__confirm {
      color: #006cff;
    }
  }
}
.img-icon {
  width: 100px;
  height: 100px;
}
.popup-wrapper {
  width: 100%;
  height: 100%;
  .line {
    width: 40px;
    height: 4px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    margin: 0 auto 10px;
  }
}
.bottom-bar {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  align-items: center;
  border-top: 1px solid #edeff2;
  gap: 10px;
  .button {
    flex: 1;
    height: 50px;
    background: #f5f7fa;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    font-size: var(--set-font-size14);
    color: #919499;
    text-align: center;
    border-radius: 25px;
    &.active {
      color: #fff;
      background: linear-gradient(270deg, #00a5ff 0%, #006cff 100%);
    }
  }
}
.main-wrapper {
  position: relative;
  background: #fff;
  padding: 20px 16px 106px;
  border-radius: 18px 18px 0px 0px;
  box-sizing: border-box;
  height: calc(100% - 0.14rem);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-size: 10px;
  font-size: var(--set-font-size10);
  color: #202124;
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    font-size: var(--set-font-size16);
    color: #202124;
    line-height: 1;
    margin-bottom: 16px;
  }
}
.time-date-wrap {
  width: 100%;
}
.time-date-time {
  width: 100%;
  display: flex;
  align-items: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  font-size: var(--set-font-size14);
  color: #202124;
  line-height: 22px;
  font-style: normal;
  padding: 16px 20px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #fff;
  border: 1px solid #f5f7fa;
  .v-line {
    width: 1px;
    height: 24px;
    background: #edeff2;
    margin: 0 10px;
  }
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
  .value.empty {
    color: #919499;
  }
}
</style>
